import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import 'bootstrap-icons/font/bootstrap-icons.css'
import 'vue3-toastify/dist/index.css'
import '@composables/utils/setupDatadog'

import { requestFlutterVersion } from '@composables/utils/requestFlutterVersion'
import { registerServiceWorker } from '@composables/utils/setupRegisterServiceWorker'
import { setupSentry } from '@composables/utils/setupSentry'
import router from '@router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createMetaManager } from 'vue-meta'
import Vue3Toasity from 'vue3-toastify'

import App from '@/App.vue'
import { mobileVersion } from '@/composables/utils/mobileVersion'

declare global {
  interface Window {
    WebAppCallback: {
      releaseName: (version: string) => void
    }
  }
}

window.WebAppCallback = {
  releaseName: (version: string) => {
    mobileVersion.value = version
  }
}

requestFlutterVersion()

registerServiceWorker()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
app.use(router)
app.use(pinia)
app.use(Vue3Toasity)
app.use(createMetaManager())
setupSentry(app)
app.mount('#app')
